import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {ReactiveFormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import { NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import {LoginService} from "./components/login/login.service";
import {RegisterService} from "./components/register/register.service"
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainMenuComponent } from './components/header/main-menu/main-menu.component';
import { FunctionalMenuComponent } from './components/header/functional-menu/functional-menu.component';
import {routing} from "./app.routing";
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { RegisterComponent } from './components/register/register.component';
import { TileComponent } from './components/home/tile/tile.component';
import { ActivateComponent } from './components/activate/activate.component';
import {ActivateService} from "./components/activate/activate.service";
import { EnquiryComponent } from './components/home/enquiry.component';
import { NewsletterComponent } from './components/home/newsletter.component';
import { ChangePasswordComponent } from './components/reset-password/change-password/change-password.component';
import {ResetPasswordService} from "./components/reset-password/reset-password.service";
import {HeaderService} from "./components/header/header.service";
import { TopMenuComponent } from './components/top-menu/top-menu.component';
import {TopMenuService} from "./components/top-menu/top-menu.service";
import {LoaderService} from "./components/spinner/loader.service";
import {LoaderModule} from "./loader/loader.module";
import { NotifierComponent } from './components/notifier/notifier.component';
import {NotifierService} from "./components/notifier/notifier.service";
import { UserListComponent } from './components/user-list/user-list.component';
import { UserListService } from './components/user-list/user-list.service';
import { UserListPagerService } from './components/user-list/pager.service';
import {ChangePasswordService} from "./components/reset-password/change-password/change-password.service";
import { SpinnerComponent } from './components/spinner/spinner.component';
import {SetService} from './components/sets/set.service'
import { SetsPagerService } from "./components/sets/pager.service";
import { SetsComponent } from './components/sets/sets.component';
import { GroupsComponent } from './components/groups/groups.component';
import {GroupsService} from "./components/groups/groups.service";
import {GroupsPagerService} from "./components/groups/groups-pager.service";
import { ReportsComponent } from './components/reports/reports.component';
import { ReportsPagerService} from './components/reports/pager.service';
import { ReportsService } from './components/reports/reports.service';
import { AddReportsComponent } from './components/reports/add-reports/add-reports.component';
import {CommonService} from "./common/common.service";
import { UserReportsComponent } from './components/user-reports/user-reports.component';
import {UserReportsService} from "./components/user-reports/user-reports.service";
import {UserReportsPagerService} from "./components/user-reports/user-reports-pager.service";
import {AdminGuardService} from "./common/admin-guard.service";
import {UserGuardService} from "./common/user-guard.service";
import { LogoutComponent } from './components/logout/logout.component';
import { UserSavedReportsComponent } from './components/user-saved-reports/user-saved-reports.component';
import {UserSavedReportsPageService} from "./components/user-saved-reports/user-saved-reports-page.service";
import {UserSavedReportsService} from "./components/user-saved-reports/user-saved-reports.service";
import { UserSettingComponent } from './components/user-setting/user-setting.component';
import {UserSettingsService} from "./components/user-setting/user-settings.service";
import { UserHelpComponent } from './components/user-help/user-help.component';
import { UserSuggestedReportsComponent } from './components/user-suggested-reports/user-suggested-reports.component';
import {UserSuggestedReportsService} from "./components/user-suggested-reports/user-suggested-reports.service";
import { UserContactComponent } from './components/user-contact/user-contact.component';
import {UserContactService} from "./components/user-contact/user-contact.service";
import {NgxMaskModule} from "ngx-mask";
import { GroupCreateComponent } from './components/group-create/group-create.component';
import {GroupCreateService} from "./components/group-create/group-create.service";
import { SuggesterHorizontalComponent } from './components/suggester-horizontal/suggester-horizontal.component';
import { SingleReportComponent } from './components/single-report/single-report.component';
import { SuggesterVerticalComponent } from './components/suggester-vertical/suggester-vertical.component';
import { SharedReportsComponent } from './components/shared-reports/shared-reports.component';
import {LogService} from './common/log.service';
import { InfobankComponent } from './components/infobank/infobank.component';
import { Search24Component } from './components/search24/search24.component';
import { UserNeedsComponent } from './components/user-needs/user-needs.component';
import { MonitorJstComponent } from './components/monitor-jst/monitor-jst.component';
import { SourceDocsComponent } from './components/source-docs/source-docs.component';
import { MarketTrendsComponent } from './components/market-trends/market-trends.component';
import { CheckBankComponent } from './components/check-bank/check-bank.component';
import { AgroCalcComponent } from './components/agro-calc/agro-calc.component';
import {UserSuggestedReportsPagerService} from "./components/user-suggested-reports/user-suggested-reports-pager.service";
import {MainMenuService} from "./components/header/main-menu/main-menu.service";
import {SingleReportService} from "./components/single-report/single-report.service";
import { UserCookiesComponent } from './components/user-cookies/user-cookies.component';
import { UserPrivacyComponent } from './components/user-privacy/user-privacy.component';
import {UserPrivacyService} from "./components/user-privacy/user-privacy.service";
import {UserCookiesService} from "./components/user-cookies/user-cookies.service";
import { UserRulesComponent } from './components/user-rules/user-rules.component';
import {UserRulesService} from "./components/user-rules/user-rules.service";
import { UserSearchBoxComponent } from './components/user-search-box/user-search-box.component';
import { UserSearchResultsComponent } from './components/user-search-results/user-search-results.component';
import {UserSearchResultsPagerService} from "./components/user-search-results/user-search-results-pager.service";
import {UserSearchResultsService} from "./components/user-search-results/user-search-results.service";
import {UserSearchBoxService} from "./components/user-search-box/user-search-box.service";
import {MasbitHttpService} from './common/http/masbit-http.service';
import { ContactPromptHorizontalComponent } from './components/contact-prompt-horizontal/contact-prompt-horizontal.component';
import {CanDeactivateAddReportsService} from "./common/can-deactivate-add-reports.service";
import { BreadcumbsComponent } from './components/breadcumbs/breadcumbs.component';
import { BreadcumbsService } from './components/breadcumbs/breadcumbs.service';
import {JoyrideModule} from 'ngx-joyride'
import { StartTourComponent } from './components/start-tour/start-tour.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import { NgxTextOverflowClampModule } from "ngx-text-overflow-clamp";
import { UserRegulationsComponent } from './components/user-regulations/user-regulations.component';
import {UserRegulationsService} from "./components/user-regulations/user-regulations.service";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    MainMenuComponent,
    FunctionalMenuComponent,
    ResetPasswordComponent,
    RegisterComponent,
    TileComponent,
    ActivateComponent,
    EnquiryComponent,
    NewsletterComponent,
    ChangePasswordComponent,
    TopMenuComponent,
    SpinnerComponent,
    NotifierComponent,
    GroupsComponent,
    UserListComponent,
    SetsComponent,
    ReportsComponent,
    AddReportsComponent,
    UserReportsComponent,
    LogoutComponent,
    UserSavedReportsComponent,
    UserSettingComponent,
    UserHelpComponent,
    UserSuggestedReportsComponent,
    UserContactComponent,
    GroupCreateComponent,
    SuggesterHorizontalComponent,
    SingleReportComponent,
    SuggesterVerticalComponent,
    SharedReportsComponent,
    InfobankComponent,
    Search24Component,
    UserNeedsComponent,
    MonitorJstComponent,
    SourceDocsComponent,
    MarketTrendsComponent,
    CheckBankComponent,
    AgroCalcComponent,
    UserCookiesComponent,
    UserPrivacyComponent,
    UserRulesComponent,
    UserSearchBoxComponent,
    UserSearchResultsComponent,
    ContactPromptHorizontalComponent,
    BreadcumbsComponent,
    StartTourComponent,
    PageNotFoundComponent,
    UserRegulationsComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoaderModule,
    routing,
    FormsModule,
    NgbModule.forRoot(),
    NgxDropzoneModule,
    NgxMaskModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    JoyrideModule.forRoot(),
    // RouterModule.forRoot([]),
    BrowserModule,
    NgSelectModule,
    NgxTextOverflowClampModule
  ],
  bootstrap: [AppComponent],

  providers: [
    LoginService,
    RegisterService,
    ActivateService,
    HeaderService,
    ResetPasswordService,
    TopMenuService,
    LoaderService,
    NotifierService,
    UserListService,
    UserListPagerService,
    SetsPagerService,
    ReportsPagerService,
    ChangePasswordService,
    SetService,
    GroupsService,
    GroupsPagerService,
    NgbDatepicker,
    LoaderService,
    NotifierService,
    ReportsService,
    CommonService,
    UserReportsService,
    UserReportsPagerService,
    AdminGuardService,
    UserGuardService,
    UserSavedReportsPageService,
    UserSavedReportsService,
    UserSettingsService,
    UserSuggestedReportsService,
    UserContactService,
    GroupCreateService,
    LogService,
    UserSuggestedReportsPagerService,
    MainMenuService,
    SingleReportService,
    UserPrivacyService,
    UserCookiesService,
    UserRulesService,
    UserSearchResultsPagerService,
    UserSearchResultsService,
    UserSearchBoxService,
    MasbitHttpService,
    CanDeactivateAddReportsService,
    BreadcumbsService,
    UserRegulationsService
    ],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
